// extracted by mini-css-extract-plugin
module.exports = {"list":"order-card-list_list__3bxhW"};